import { IApplicationState } from '../../types/redux';

export const getTransportRating = (state: IApplicationState): number | null => {
  return state.newReview.data.transportRating.value;
};
